<template>
  <nav class="text-light">
    <ul class="list-unstyled">
      <li v-for="theme in themes" :key="theme.day" data-bs-dismiss="offcanvas">
        <router-link :to="theme.route"
          ><span>{{ theme.day }}</span> {{ theme.title }}</router-link
        >
      </li>
    </ul>
  </nav>
</template>

<script>
import themes from "../assets/themes.json";
export default {
  name: "MobileNavigation",
  data() {
    return {
      themes: themes,
    };
  },
  props: {
    msg: String,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
a {
  text-decoration: none;
  color: #fff;
  display: block;
  padding: 0.5rem 1rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  transition: all 250ms ease;

  &:hover {
    background-color: #535252;
    color: #ffffff;
  }

  span {
    display: inline-flex;
    background-color: #191919;
    padding: 0 0.5rem;
    color: #ffffff;
  }
}
</style>
